import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Input } from "@/components/ui/input";
import { formatCurrency } from "@/lib/format";
import { Empty } from "@/components/Empty";

export default function Producten() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/products", { params: { search: search || undefined } })
      .then((r) => setProducts(r.data));
  }, [search]);

  return (
    <div className="px-4 md:px-8 lg:px-12 py-8 md:py-10" data-testid="products-page">
      <PageHeader
        eyebrow="Assortiment"
        title="Producten"
        description="Overzicht van alle producten in het assortiment. Klik op een product voor details."
      />

      <div className="surface p-3 md:p-4 mb-6 relative">
        <Search className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        <Input data-testid="products-search" placeholder="Zoek product…" value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="pl-11 h-12 text-base border-0 bg-transparent" />
      </div>

      {products.length === 0 ? (
        <Empty title="Geen producten gevonden." />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {products.map((p) => (
            <Link key={p.id} to={`/producten/${p.id}`} data-testid={`product-card-${p.article_number}`}
              className="surface p-5 hover:border-primary/40 transition-colors block">
              <div className="text-xs font-mono text-muted-foreground">{p.article_number}</div>
              <div className="font-semibold text-lg mt-1">{p.name}</div>
              <div className="text-sm text-muted-foreground mt-1">{p.category} · {p.supplier_name}</div>
              <div className="flex items-center justify-between mt-4">
                <span className="text-xs text-muted-foreground">Verkoopprijs</span>
                <span className="font-mono font-semibold">{formatCurrency(p.sale_price)}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
